import {
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import arrow_down from '../../assets/arrow_down.svg';
import search_icon from '../../assets/search_icon.svg';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';
import styled from 'styled-components';

export type ISearchableDropDown = {
  options?: Array<{ name: string; imageUrl: string }>;
  value?: string;
  placeholder?: string;
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  onSelect?: (item: string, index: number) => void;
};
export const SearchableDropDown: FC<ISearchableDropDown> = ({
  value,
  options,
  children,
  placeholder,
  onSelect,
  search,
  setSearch,
  ...rest
}) => {
  const node = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  const clickOutside = useCallback(
    (e: MouseEvent) => {
      if (node.current?.contains(e.target as HTMLDivElement)) return;
      setShow(false);
      setSearch('');
    },
    [setSearch]
  );

  const handleSelect = (item: string, index: number) => {
    setShow(false);
    setSearch('');
    if (onSelect) onSelect(item, index);
  };

  useEffect(() => {
    document.addEventListener('mousedown', clickOutside);
    return () => {
      document.removeEventListener('mousedown', clickOutside);
    };
  }, [show, clickOutside]);
  return (
    <Container ref={node} {...rest}>
      <DropdownHeader onClick={() => setShow(!show)}>
        <DropDownTxt isPlaceholder={value === '' && !!placeholder}>
          {value === '' && placeholder ? placeholder : value}
        </DropDownTxt>
        <Icon src={arrow_down} />
      </DropdownHeader>
      <DropdownContent show={show} id="content">
        <Input
          placeholder="Search ..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <SearchIcon src={search_icon} />
        {children}
        {options?.map((item, index) => (
          <DropDownItem
            key={index.toString()}
            onClick={() => handleSelect(item.name, index)}
          >
            <Profile src={item.imageUrl} />
            {item.name}
          </DropDownItem>
        ))}
      </DropdownContent>
    </Container>
  );
};

const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 8px 16px;
  position: relative;
  position: relative;
  cursor: pointer;
`;
const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
`;
const Icon = styled.img``;
const DropDownTxt = styled.p<{ isPlaceholder?: boolean }>`
  font-family: DM Sans;
  color: ${({ isPlaceholder }) =>
    isPlaceholder ? '#a1a1a1' : colors.textDark};
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(14)};
  flex: 1;
`;

export const DropdownContent = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  top: 40px;
  right: 0;
  background-color: #ffffff;
  overflow: hidden;
  width: 100%;
  overflow-y: auto;
  max-height: 250px;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.2),
    0px 1px 3px rgba(50, 50, 71, 0.1);
  border-radius: 8px;
  z-index: 10;
  & button {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }
  & button:hover {
    background-color: #f1f1f1;
  }
`;
export const DropDownItem = styled.div`
  background-color: transparent;
  border: none;
  text-align: left;
  width: 90%;
  display: flex;
  align-items: center;
  margin: auto;
  padding: 8px 0px;
`;
const Input = styled.input`
  padding: 8px 28px;
  margin: 12px auto;
  border-radius: 6px;
  border: 1px solid #b5b5bd;
  width: 75%;
  display: flex;
  justify-content: center;

  ::placeholder {
    color: #b5b5bd;
  }
`;
const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 22px;
`;
const Profile = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  margin-right: 20px;
  object-fit: cover;
`;
